module.exports = __webpack_public_path__ + "images/[14]1-photo nuit2.2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/slider/[14]1-photo nuit2.2.jpg
// module id = 45
// module chunks = 0